export default __webpack_public_path__ + "static/media/Sauces & Spreads.9748b20c.png";